import React, { Component } from 'react';
import SubmitButton from '../buttons/submitButton';
import './checkboxText.css'

class CheckboxText extends Component {

  state = {
    buttonsEnabled: true,
  }

  renderColor(item) {
    if (this.props.selectedItems.includes(item)) {
      return {color: '#fff', background: '#6A93A8'}
    } else {
      return {color: '#6A93A8'}
    }
  }

  disableButtons(timeout) {
    this.setState({buttonsEnabled: false})

    setTimeout(() => {
      this.setState({buttonsEnabled: true})
    }, timeout)
  }

  render() {
    return(
      <div className="user-row">

        <div className="checkbox-text-wrapper">
          <div className="checkbox-text-box">
            {
              Object.keys(this.props.data).map(item =>
                <div
                  key={item}
                  style={{color: this.renderColor(item).color, background: this.renderColor(item).background}}
                  onClick={() => this.state.buttonsEnabled && this.props.setItems(item)}
                  className="select-button drop-shadow"
                >

                  {this.props.data[item]}

                </div>
              )
            }
          </div>

          {this.props.selectedItems.length >= 1 && this.props.itemsSaved === false &&
            <div className="checkbox-text-submit-box">
              <SubmitButton
                action={(timeout) => this.props.saveItems(timeout)}
                label={this.props.buttonText}
                disableButtons={(timeout) => this.disableButtons(timeout)}
              />
          </div>
          }

        </div>


        {this.props.companyLogo.length > 0 &&
          <div className="user-avatar-company-logo">
            <img
              src={`${this.props.companyLogo}`}
              alt=""
              style={{width: '100%'}}
            />
          </div>
        }

        {this.props.companyLogo.length === 0 &&
          <div className="user-avatar">
            {this.props.companyName.charAt(0).toUpperCase()}
          </div>
        }
      </div>
    )
  }
}


export default CheckboxText;
